import Axios from 'axios'

import { McpPlatform, McpPlatformAccess } from 'types/GlobalMcpPlatformAccess'

import { parseAuthenticationHeader } from 'helpers/Functions'

const BASE_URL =
  process.env.NODE_ENV === 'development'
    ? 'http://localhost:3990/'
    : process.env.REACT_APP_HOMEPAL_MDM_API_PROD

const URL = `${BASE_URL}v1/mcp-platform-access`

export async function getAll() {
  return Axios.get<{ data: McpPlatformAccess }>(
    URL,
    parseAuthenticationHeader()
  )
}

// Disabling a platform also revokes every existing connection to it.
export async function setEnabled(platform: McpPlatform, enabled: boolean) {
  return Axios.put<{ data: McpPlatformAccess }>(
    `${URL}/${platform}`,
    { data: { enabled } },
    parseAuthenticationHeader()
  )
}
